import React from 'react';
import { useLoginAppearance } from './LoginAppearanceContext';
import { resolveBrandLogoUrl } from '../lib/brandLogo';
import { BrandLogoImage } from './BrandMark';

/** Authentication has no appearance controls. Keep the slot for existing callers. */
export function AuthThemeSlot() { return null; }

/** Shared branding for login, registration and password recovery. */
export default function AuthCardHeader({ visual, children }) {
  const appearance = useLoginAppearance();
  if (appearance) {
    if (!appearance.login_show_brand) return null;
    const logo = resolveBrandLogoUrl(appearance, appearance.theme === 'dark' ? 'dark' : 'light');
    return <div className="auth-card-header"><div className="login-aurax__card-brand login-layout-brand">
      {logo ? <BrandLogoImage src={logo} alt={appearance.brand_name} className="login-aurax__logo-free" /> : <span className="login-layout-monogram" aria-hidden="true">{appearance.brand_name.slice(0, 1).toUpperCase()}</span>}
      {!logo && <span className="login-layout-brand-name">{appearance.brand_name}</span>}
    </div></div>;
  }
  if (visual !== 'modern') return children;
  return <div className="auth-card-header">{children}</div>;
}
